import { render } from "./GoToTopButton.vue?vue&type=template&id=68ca9a27&scoped=true"
import script from "./GoToTopButton.vue?vue&type=script&lang=js"
export * from "./GoToTopButton.vue?vue&type=script&lang=js"

import "./GoToTopButton.vue?vue&type=style&index=0&id=68ca9a27&scoped=true&lang=css"

import exportComponent from "/Users/deniel/Documents/projects/translator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ca9a27"]])

export default __exports__